import type { ReactNode } from 'react';
import { createContext, useContext, useMemo } from 'react';
import type { ChatConfig } from '../types';

export interface ChatContextValue {
  config: ChatConfig;
}

export interface ChatContextProviderProps {
  config: ChatConfig;
  children: ReactNode;
}

const ChatContext = createContext<ChatContextValue | null>(null);

export function ChatContextProvider(props: ChatContextProviderProps) {
  const { config, children } = props;

  const value: ChatContextValue = useMemo(
    () => ({
      config,
    }),
    [config]
  );

  return <ChatContext.Provider value={value}>{children}</ChatContext.Provider>;
}

export function useChatContext(): ChatContextValue {
  const context = useContext(ChatContext);

  if (!context) {
    throw new Error('useChatContext must be used within a ChatContextProvider');
  }

  return context;
}
